<h1 ev-dialog-title>{{ languageService.languageJSON.TabbedInfoDialog_Welcome }}</h1>

<div ev-dialog-content class="scrollable" data-testid="welcome-container">
  <div class="welcome-content">
    <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
  </div>
</div>

<div ev-dialog-actions>
  @if (firstInit) {
  <button class="ev-button primary" name="start_button" mat-button (click)="onStartClick()" data-testid="welcome-start-btn">
    Start
  </button>
  <button class="ev-button" mat-button (click)="onOpenTutorialClick()" data-testid="welcome-tutorial-btn">
    {{ languageService.languageJSON.TabbedInfoDialog_Tutorial }}
  </button>
  } @else {
  <button class="ev-button primary" name="ok_button" mat-button (click)="dialogRef?.close()" data-testid="welcome-close-btn">
    {{ languageService.languageJSON.Global_Close }}
  </button>
  }
</div>

<ng-template #contentTpl>

  <div class="welcome-logo">
    @if (terahive) {
    <img class="terahive-logo" [src]="'/assets/icons/' + settingsService.getMap().Skin + '/logo/terahive_logo.png'" />
    }
    <img class="ev-logo" [src]="'/assets/icons/' + settingsService.getMap().Skin + '/logo/ev_navigation_logo.png'" />
    <div class="gpst-logo-section">
      <a href="https://gpstuner.com/" data-testid="welcome-gpst-link">
        <img [src]="'/assets/icons/' + settingsService.getMap().Skin + '/logo/navity_logo.svg'" />
      </a>
    </div>
  </div>

  <app-modal-option-panel>
    <p class="intro-text">{{ languageService.languageJSON.Tutorial_Step_0_Text }}</p>
  </app-modal-option-panel>

  <div class="store-buttons">
    <a href="https://play.google.com/store/apps/details?id=com.gpstuner.evnavigation" target="_blank" data-testid="welcome-google-play-link">
      @if (!ios) {
      <img class="store-img google"
        [src]="'assets/icons/default/social/' + languageService.getStoreBadgeLanguage() + '/google_play_button.svg'"
        alt="Google Play" />
      }
    </a>
    <a href="https://apps.apple.com/app/ev-navigation/id1494131819" target="_blank" data-testid="welcome-app-store-link">
      <img class="store-img apple"
        [src]="'assets/icons/default/social/' + languageService.getStoreBadgeLanguage() + '/app_store_button.svg'"
        alt="App Store" />
    </a>
  </div>

  <div class="social-buttons">
    <a href="https://x.com/evnavigation" target="_blank" class="social-btn x" data-testid="welcome-twitter-link">
      <span class="x-logo" aria-hidden="true"></span>
      {{ languageService.languageJSON.Welcome_Twitter }}
    </a>
    <a href="https://www.facebook.com/EVNavigation" target="_blank" class="social-btn facebook" data-testid="welcome-facebook-link">
      <img class="fb-logo" src="assets/icons/default/social/facebook_icon.svg" alt="Facebook" />
      {{ languageService.languageJSON.Welcome_Facebook }}
    </a>
  </div>

  @if(!firstInit){
  <app-modal-option-panel>
    <span panel-title>{{ languageService.languageJSON.Changelog_WhatsNew }}</span>

    <div class="changelog-stack">

      <div class="changelog-element">
        <div class="changelog-row">
          <div class="changelog-col main">
            @if (changeLogData[0].features.length > 0) {
            <div class="changelog-type-outer">
              <span class="changelog-type-icon"
                [style.--icon]="'url(assets/icons/' + settingsService.getMap().Skin + '/ui/feature_icon.svg)'"></span>
              <div class="logs">
                <h4>{{ languageService.languageJSON.Changelog_Features }}</h4>
                <ul>
                  @for (log of changeLogData[0].features; track log) {
                  <li>{{ logText(log) }}</li>
                  }
                </ul>
              </div>
            </div>
            }
            @if (changeLogData[0].improvements.length > 0) {
            <div class="changelog-type-outer">
              <span class="changelog-type-icon"
                [style.--icon]="'url(assets/icons/' + settingsService.getMap().Skin + '/ui/improvement_icon.svg)'"></span>
              <div class="logs">
                <h4>{{ languageService.languageJSON.Changelog_Improvements }}</h4>
                <ul>
                  @for (log of changeLogData[0].improvements; track log) {
                  <li>{{ logText(log) }}</li>
                  }
                </ul>
              </div>
            </div>
            }
            @if (changeLogData[0].bugfixes.length > 0) {
            <div class="changelog-type-outer">
              <span class="changelog-type-icon"
                [style.--icon]="'url(assets/icons/' + settingsService.getMap().Skin + '/ui/bugfix_icon.svg)'"></span>
              <div class="logs">
                <h4>{{ languageService.languageJSON.Changelog_Bugfixes }}</h4>
                <ul>
                  @for (log of changeLogData[0].bugfixes; track log) {
                  <li>{{ logText(log) }}</li>
                  }
                </ul>
              </div>
            </div>
            }
          </div>
          @if (changeLogData[0].version) {
          <div class="changelog-col version-col">
            <div class="version-badge">v{{ changeLogData[0].version }}</div>
          </div>
          }
        </div>
      </div>

      <div class="changelog-opener-outer">
        <button type="button" class="changelog-opener" [class.opened]="changelogDetailed()"
          (click)="changelogDetailed.set(!changelogDetailed())" data-testid="welcome-changelog-toggle-btn">
          <img class="clock-icon"
            [src]="'assets/icons/' + settingsService.getMap().Skin + '/ui/computer_icon_clock.svg'" />
          <span>{{ languageService.languageJSON.Changelog_VersionHistory }}</span>
          <img class="opener-icon" [src]="'assets/icons/' + settingsService.getMap().Skin + '/ui/open_arrow.svg'" />
        </button>
      </div>

      @for (changeLog of changeLogData; track changeLog; let i = $index) {
      <div class="changelog-element" [hidden]="i === 0 || !changelogDetailed()">
        <div class="changelog-row">
          <div class="changelog-col main">
            @if (changeLog.title) {
            <div class="changelog-type-outer">
              <div class="logs">
                <h4>{{ logText(changeLog.title) }}</h4>
              </div>
            </div>
            }
            @if (changeLog.features.length > 0) {
            <div class="changelog-type-outer">
              <span class="changelog-type-icon"
                [style.--icon]="'url(assets/icons/' + settingsService.getMap().Skin + '/ui/feature_icon.svg)'"></span>
              <div class="logs">
                <h4>{{ languageService.languageJSON.Changelog_Features }}</h4>
                <ul>
                  @for (log of changeLog.features; track log) {
                  <li>{{ logText(log) }}</li>
                  }
                </ul>
              </div>
            </div>
            }
            @if (changeLog.improvements.length > 0) {
            <div class="changelog-type-outer">
              <span class="changelog-type-icon"
                [style.--icon]="'url(assets/icons/' + settingsService.getMap().Skin + '/ui/improvement_icon.svg)'"></span>
              <div class="logs">
                <h4>{{ languageService.languageJSON.Changelog_Improvements }}</h4>
                <ul>
                  @for (log of changeLog.improvements; track log) {
                  <li>{{ logText(log) }}</li>
                  }
                </ul>
              </div>
            </div>
            }
            @if (changeLog.bugfixes.length > 0) {
            <div class="changelog-type-outer">
              <span class="changelog-type-icon"
                [style.--icon]="'url(assets/icons/' + settingsService.getMap().Skin + '/ui/bugfix_icon.svg)'"></span>
              <div class="logs">
                <h4>{{ languageService.languageJSON.Changelog_Bugfixes }}</h4>
                <ul>
                  @for (log of changeLog.bugfixes; track log) {
                  <li>{{ logText(log) }}</li>
                  }
                </ul>
              </div>
            </div>
            }
          </div>
          @if (changeLog.version) {
          <div class="changelog-col version-col">
            <div class="version-badge">v{{ changeLog.version }}</div>
          </div>
          }
        </div>
      </div>
      }

    </div>
  </app-modal-option-panel>}
</ng-template>